module.exports = __webpack_public_path__ + "static/media/Design1-desktop.3a8d638f.svg";